import { createSlice } from '@reduxjs/toolkit';

import { authApi } from './authApi';
import { profileApi } from '@/modules/profile';
import { saveToken, deleteToken } from '@/shared';

import type { TAuthState } from './types';

export const initialAuthState: TAuthState = {
  isAuth: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    exitUser(state) {
      state.isAuth = false;
      deleteToken();
    },
  },
  extraReducers: (build) => {
    build
      .addMatcher(authApi.endpoints.login.matchFulfilled, (state: TAuthState, action) => {
        state.isAuth = true;
        const token = action.payload.access_token;
        saveToken(token);
      })
      .addMatcher(profileApi.endpoints.getUserInfo.matchFulfilled, (state: TAuthState) => {
        state.isAuth = true;
      })
      .addMatcher(profileApi.endpoints.getUserInfo.matchRejected, (_, action) => {
        if (action.payload && action.payload.status === 401) {
          deleteToken();
        }
      })
  },
});

export { authSlice };

export const exitUser = authSlice.actions.exitUser;
